export default __webpack_public_path__ + "static/media/movies_light.e184c8f0.png";